// extracted by mini-css-extract-plugin
module.exports = {"home-page":"Home_home-page__1cmQP","primary-link":"Home_primary-link__3AoDn","page-content":"Home_page-content__1k6HO"};